import { AxiosResponse } from "axios";
import axiosInstance from "../api/axios";

export const requestAccount = async (userId: number, file: any) => {
  try {
    const formData = new FormData();
    formData.append("user_id", userId.toString());
    formData.append("comment", "User Request");
    if (file) {
      formData.append("document", file);
    }
    const response: AxiosResponse<any> = await axiosInstance.post(
      "/user-approval-request", formData
    );
    console.log("Requested successfully:", response.data);
    return response.data;
    // Handle success (e.g., navigate to another page)
  } catch (error: any) {
    console.error(
      "Account request failed:",
      error.response?.data || error.message
    );
    // Handle failure (e.g., show an error message)
    return null;
  }
};
